import { render } from "./Exports.vue?vue&type=template&id=dbd57e44&ts=true"
import script from "./Exports.vue?vue&type=script&lang=ts"
export * from "./Exports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__